import SelectionCard from 'components/DesignSystem/SelectionCard/SelectionCard';
import Icon from 'components/common/Icon';

interface SurveyTypeProps {
  selectedSurveyType?: string;
  setSelectedSurveyType: (arg: string) => void;
}

export const FULL_SERVICE = 'Full-Service';
export const HYBRID = 'Hybrid';
export const DIY = 'DIY';

const SurveyTypePanel = ({
  selectedSurveyType,
  setSelectedSurveyType,
}: SurveyTypeProps) => {
  return (
    <div className="flex flex-grow flex-col rounded-lg shadow p-8 text-left h-fit gap-4 bg-white">
      <div>
        <p className="font-bold text-2xl">Choose your survey type</p>
        <p className="text-gray-500">
          Select how involved you'd like Glass to be in your research project.
        </p>
      </div>
      <SelectionCard
        descriptionPillTexts={[
          'Methodology & Approach',
          'Questionnaire Design',
          'Programming',
          'Survey Review',
          'Field Management',
        ]}
        descriptionText="We handle everything - strategy, design, programming, fielding, and delivery"
        icon={<Icon id="check" />}
        isSelected={selectedSurveyType === FULL_SERVICE}
        onClick={() => setSelectedSurveyType(FULL_SERVICE)}
        titlePillText="Most Popular"
        titleText={FULL_SERVICE}
      />
      <SelectionCard
        descriptionPillTexts={[
          'Choose your services',
          'Expert support where you need it',
          'Field ready programming',
        ]}
        descriptionText="You choose which design and fielding services to add to your self-managed survey."
        icon={<Icon id="paragraph-mixed" />}
        isSelected={selectedSurveyType === HYBRID}
        onClick={() => setSelectedSurveyType(HYBRID)}
        titlePillText="Flexible"
        titleText={HYBRID}
      />
      <SelectionCard
        descriptionPillTexts={[
          'Access to respondent panel',
          'Survey platform access',
          'Basic reporting',
        ]}
        descriptionText="You design and manage your survey independently. We provide the panel and platform"
        icon={<Icon id="sliders" />}
        isSelected={selectedSurveyType === DIY}
        onClick={() => setSelectedSurveyType(DIY)}
        titlePillText="Self-Serve"
        titleText={DIY}
      />
    </div>
  );
};

export default SurveyTypePanel;
